export default __webpack_public_path__ + "static/media/i20.b20b90db.jpeg";